import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=9832b9d6&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=9832b9d6&prod&scoped=true&lang=css"
import style1 from "./ContactDetail.vue?vue&type=style&index=1&id=9832b9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9832b9d6",
  null
  
)

export default component.exports